import React from 'react';
import { VStack, Box, HStack } from '@chakra-ui/react';
import MarkdownRenderer from '../../Common/MarkdownRenderer';

const TeamActivityContent = ({ desc, hashtags }) => {
  // Check if content contains markdown syntax
  const hasMarkdownSyntax = (content) => {
    if (!content) return false;
    
    const markdownPatterns = [
      /#{1,6}\s+/, // Headers
      /\*{1,2}[^*]+\*{1,2}/, // Bold/Italic
      /`[^`]+`/, // Inline code
      /```[\s\S]*?```/, // Code blocks
      /\[.+\]\(.+\)/, // Links
      /<a\s+[^>]*href\s*=\s*["'][^"']*["'][^>]*>.*?<\/a>/i, // HTML links
      /https?:\/\/[^\s<>]+/, // Plain URLs
      /^[-*+]\s+/m, // Unordered lists
      /^\d+\.\s+/m, // Ordered lists
      /^>\s+/m, // Blockquotes
      /^\|.+\|/m, // Tables
      /---+/, // Horizontal rules
    ];
    
    return markdownPatterns.some(pattern => pattern.test(content));
  };

  const shouldUseMarkdown = hasMarkdownSyntax(desc);
  
  return (
    <VStack spacing={4} align="stretch" width="100%" pb={12}>
      {desc && (
        <Box width="100%">
          {shouldUseMarkdown ? (
            <MarkdownRenderer 
              content={desc}
              width="100%"
              sx={{
                "& p": {
                  margin: "0",
                  lineHeight: "1.4",
                  color: "gray.700",
                  marginBottom: "0.5rem"
                },
                "& ul, & ol": {
                  lineHeight: "1.4",
                  marginBottom: "0.5rem"
                },
                "& li": {
                  lineHeight: "1.4",
                  marginBottom: "0.25rem"
                },
                "& h1, & h2, & h3, & h4, & h5, & h6": {
                  lineHeight: "1.4",
                  marginBottom: "0.5rem"
                }
              }}
            />
          ) : (
            <Box
              fontSize="lg" 
              color="gray.700" 
              lineHeight="1.2"
              whiteSpace="pre-wrap"
              wordBreak="break-word"
              width="100%"
            >
              {desc.split('\n').map((line, idx) => (
                <Box key={idx} mb={line.trim() === '' ? 4 : 0}>
                  {line}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      )}
      
      {hashtags && hashtags.length > 0 && (
        <HStack spacing={2} mt={4} flexWrap="wrap">
          {hashtags.map((tag, idx) => (
            <Box key={idx} as="span" color="teal.600" fontWeight="semibold" fontSize="md">
              {typeof tag === 'object' ? (tag.name || tag.text || JSON.stringify(tag)) : String(tag)}
            </Box>
          ))}
        </HStack>
      )}
    </VStack>
  );
};

export default TeamActivityContent; 